import { getCookie } from '../../utils/cookies'
import {
  analyticalCookies,
  Cookies,
  functionalCookies,
  getCurrentCookie,
  no,
  trackingCookies,
  videoCookies,
} from '../../utils/hoppingerCookies'

export type CookiebarState = {
  selectedCookies: Cookies
  cookies: Cookies
  expandOptions: boolean
  visible: boolean
}

export const showCookies = 'showCookies'

export const initialCookiebarState = (): CookiebarState => {
  const currentCookies: Cookies = {
    [functionalCookies]: getCurrentCookie(functionalCookies),
    [analyticalCookies]: getCurrentCookie(analyticalCookies),
    [videoCookies]: getCurrentCookie(videoCookies),
    [trackingCookies]: getCurrentCookie(trackingCookies),
  }
  return {
    cookies: currentCookies,
    selectedCookies: currentCookies,
    expandOptions: false,
    visible: getCookie(showCookies) != no,
  }
}
